export const SKIP_TO_CONTENT_TARGET_ID = 'chakra-skip-nav';
export const SKIP_TO_CONTENT_SELECTOR = 'a.skip-to-content';

const FOCUSED_CLASS = 'skip-to-content--focused';

/**
 * First focusable in app shell — inline DOM order (before header). No portal (SSR/tab-order safe).
 */
export function SkipToContentLink() {
  const handleClick = (event) => {
    event.preventDefault();
    document.getElementById(SKIP_TO_CONTENT_TARGET_ID)?.focus({preventScroll: true});
  };

  const handleFocus = (event) => {
    event.currentTarget.classList.add(FOCUSED_CLASS);
  };

  const handleBlur = (event) => {
    event.currentTarget.classList.remove(FOCUSED_CLASS);
  };

  return (
    <a
      className="skip-to-content"
      href={`#${SKIP_TO_CONTENT_TARGET_ID}`}
      onBlur={handleBlur}
      onClick={handleClick}
      onFocus={handleFocus}
    >
      Skip to Content
    </a>
  );
}
